import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
} from "@mui/material";

function Profile() {
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    axios
      .get(
        "https://app.metabolytics.ai/simulator-backend/healthcare/api/auth/profile",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setProfile(res.data);
        setLoading(false);
      })
      .catch(() => {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("token");
        navigate("/login");
      });
  }, [navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        "https://app.metabolytics.ai/simulator-backend/healthcare/api/auth/update-password",
        { password: formData.password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Password updated successfully!");
    } catch (error) {
      alert(error.response?.data?.message || "Error updating password.");
    }
    setUpdating(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  if (loading) return <CircularProgress />;

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 3, marginTop: 5 }}>
        <Typography variant="h4" gutterBottom>
          Admin Profile
        </Typography>
        <Typography variant="h6">Username: {profile.username}</Typography>
        <Typography variant="h6">Email: {profile.email}</Typography>
        <Typography variant="h6">Role: {profile.role}</Typography>

        <Typography variant="h5" gutterBottom sx={{ marginTop: 3 }}>
          Change Password
        </Typography>
        <form onSubmit={handlePasswordUpdate}>
          <TextField
            fullWidth
            label="New Password"
            type="password"
            variant="outlined"
            name="password"
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            variant="outlined"
            name="confirmPassword"
            onChange={handleChange}
            required
            sx={{ mt: 2 }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2 }}
            disabled={updating}
          >
            {updating ? "Updating..." : "Update Password"}
          </Button>
        </form>

        <Button
          fullWidth
          variant="contained"
          color="secondary"
          sx={{ mt: 2 }}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Paper>
    </Container>
  );
}

export default Profile;
